<template>
  <div id="system-database-add">
    <ipub-model :title="params.id?'Edit Database':'Add Database'"
                width="900px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-form ref="database-add-form"
                 :model="params"
                 :rules="rules">
        <ipub-form-item prop="name"
                        label="Title (Suggested word count 30)">
          <ipub-editor :height="200"
                       v-model.trim="params.name" />
        </ipub-form-item>
        <ipub-form-item prop="picture"
                        label="Image Upload">
          <ipub-upload class="mar-b-20"
                       @change="handleUpload">
            <div class="upload-content">
              <img v-if="params.picture"
                   :src="`${domain}/${params.picture}`"
                   alt="">
              <ipub-icon v-else
                         type="iconAdd" />
            </div>
          </ipub-upload>
          <div class="font-color ipub-p4"> - Suggestion Size: 460 x 140 px; Only support .png and .jpg; File size need to be less than 2MB.</div>
        </ipub-form-item>
        <ipub-form-item prop="linked"
                        label="Links">
          <ipub-radio-group class="mar-b-10"
                            v-model="params.linked"
                            @change="onLinkedChange"
                            _label="name"
                            :options="[{name:'Yes',value:true},{name:'No',value:false}]" />
          <ipub-input v-if="params.linked"
                      placeholder="Enter link here"
                      v-model.trim="params.linkAddress" />
          <ipub-editor v-else
                       :height="200"
                       v-model.trim="params.linkText" />
        </ipub-form-item>
      </ipub-form>
      <div slot="footer">
        <ipub-button plain
                     type="primary"
                     :style="{minWidth: '150px'}"
                     @click="preview">Save & Preview</ipub-button>
        <ipub-button plain
                     v-if="!params.id"
                     type="primary"
                     :style="{minWidth: '150px'}"
                     @click="confirm(false)">Save</ipub-button>
        <ipub-button type="primary"
                     :style="{minWidth: '150px'}"
                     @click="confirm(true)">Publish</ipub-button>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getUploadConfig } from '../../../../utils/upload'
import database from '../../../../api/database'
import check from '../../../../utils/check'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      params: {
        linked: true,
      },
      rules: {},
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      journalId: 'getJournalId'
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {
          linked: true,
        }
      }
    }
  },
  mounted () {
    this.getRules()
  },
  methods: {
    async getQuery (id) {
      this.params = await database.query(id)
    },
    async handleUpload (files) {
      const file = files[0]
      const types = ['image/jpeg', 'image/png']
      const rightType = types.includes(file.type)
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }
      const MS = 2
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        return false
      }
      const url = await getUploadConfig(file, `${this.publisherId}/journal/${this.journalId}/database`)

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }

      this.$set(this.params, 'pictureName', file.name)
      this.$set(this.params, 'picture', url)
    },
    async confirm (val) {
      if (this.params.linked) {
        if (!this.params.linkAddress || !check.website(this.params.linkAddress)) {
          this.$message.error({ title: 'Error', content: this.LANGUAGE[this.language].enterCorrent + 'Link' })
          return
        }
      }
      const flag = this.$refs['database-add-form'].validate()
      if (flag) {
        const data = Object.assign(this.params, {
          released: val,
          journalId: this.journalId
        })
        if (this.params.id) {
          await database.edit(this.params.id, data)
          this.$message.success({ title: 'Success', content: 'This Database has been published!' })
        } else {
          await database.add(data)
          if (val) {
            this.$message.success({ title: 'Success', content: 'This Database has been published!' })
          } else {
            this.$message.success({ title: 'Success', content: 'This Database has been saved!' })
          }
        }
        this.$emit('confirm', data)
      }
    },
    onLinkedChange () {
      this.params.linkAddress = ''
      this.params.linkText = ''
    },
    preview () {

    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        name: [
          {
            required: true,
            message:
              'Title' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        picture: [
          {
            required: true,
            message:
              'Image' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        linked: [
          {
            required: true,
            message:
              'Link' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#system-database-add {
  .upload-content {
    height: 77px;
    width: 253px;
    background: $content_color;
    border: 1px solid $border_color;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
